<template>
  <div class="wallboard" :class="{fullscreen: fullscreen, 'iv-container': !fullscreen, 'iv-container-fullscreen': fullscreen}" ref="wallboard">

    <!-- Title and button -->
    <div class="row mar-b30" :class="{hide: fullscreen}">
      <div class="col-xs-12 col-sm-6">
        <h5>{{wallboard.name}}</h5>
      </div>
      <div class="col-xs-12 col-sm-6 end-xs">
        <button type="button" class="iv-btn" v-on:click="addPanel()">Add Panel</button>
      </div>
    </div>

    <!-- Spinner -->
    <div v-if="!loaded">
      <div class="spinner"></div>
    </div>

    <!-- Draggable wallboard elements -->
    <div>
      <draggable class="row noMarg" @end="calcOrder">
        <div class="panelHolder col-xs-12" v-for="(panel, index) in wallboard.definition.panels" :data-id="panel.id" :key="panel.id" :style="{height: (dimensions.baseHeight * panel.height) + 'px'}" :class="'col-md-' + panel.width">
          <Panel :panel="panel" :save="saveWallboard" :height="dimensions.baseHeight * panel.height" :index="index" :deletePanel="() => deletePanel(panel.id)" :configure="() => editPanel(panel)" :definitions="definitions" :wallboardId="id" :copy="() => duplicate(panel)"/>
        </div>
      </draggable>
    </div>
    <Drawer :isOpen="!!addingPanel" :onClose="() => drawerFull = false" :width="drawerWidth">
      <add-panel v-if="!!addingPanel" :setWidth="width => drawerWidth = width" :save="createPanel" :panel="addingPanel" :cancel="canelEdit" :definitions="definitions"/>
    </Drawer>
  </div>
</template>

<script>
import axios from "../utils/axios";
import Panel from "../components/wallboard/Panel";
import AddPanel from "../components/wallboard/configure/AddPanel";
import draggable from "vuedraggable";
import { setInterval } from "timers";
import moment from "moment-timezone";
import Vue from "vue";

export default {
  components: { Panel, AddPanel, draggable },
  created: function() {
    window.addEventListener("resize", this.handleResize);
    this.getDefinitions();

    if (this.$route.query.fullscreen && (this.$route.query.fullscreen == "true" || this.$route.query.fullscreen == "1")) {
      this.$store.commit("makeFullscreen");
    } else {
      this.$store.commit("undoFullscreen");
    }

    this.timer = setInterval(this.getDefinitions, 60 * 1000);
  },
  mounted() {
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  data() {
    return {
      timer: undefined,
      id: this.$route.params.id,
      wallboard: {
        name: "",
        definition: {
          panels: []
        }
      },
      dimensions: {
        baseHeight: 0,
        width: 0,
        height: 0
      },
      loaded: false,
      addingPanel: undefined,
      backupPanel: undefined,
      definitions: [],
      drawerWidth: ""
    };
  },
  methods: {
    getDefinitions() {
      if (this.addingPanel) return;
      axios.get("statdefinitions").then(response => {
        this.definitions = response.data;
        this.getWallboard();
      });
    },
    getWallboard() {
      axios.get("wallboards/" + this.id).then(response => {
        this.wallboard = response.data;
        this.loaded = true;
        this.handleResize();
      });
    },
    handleResize() {
      if (this.$refs && this.$refs.wallboard) {
        this.dimensions.width = this.$refs.wallboard.clientWidth;
        this.dimensions.height = this.$refs.wallboard.clientHeight;
        this.dimensions.baseHeight = this.$refs.wallboard.clientHeight / 12;
      }
    },
    calcOrder() {
      var panels = this.$refs.wallboard.getElementsByClassName("panelHolder");
      Array.from(panels).forEach((panel, index) => {
        let id = parseInt(panel.getAttribute("data-id"));
        var found = this.wallboard.definition.panels.find(p => p.id === id);
        if (found) found.order = index;
      });
      this.saveWallboard();
    },
    addPanel() {
      this.addingPanel = {
        type: "",
        width: 3,
        height: 3,
        alarms: [],
        autofit: true,
        backgroundColour: "#0094d5",
        title: { text: "", colour: "white", size: 20, autofit: false },
        content: { colour: "white", size: 28 },
        timezone: moment.tz.guess(),
        statDefinitionId: undefined
      };
      this.backupPanel = undefined;
    },
    editPanel(panel) {
      this.addingPanel = panel;
      this.backupPanel = JSON.parse(JSON.stringify(panel));
    },
    canelEdit() {
      if (this.backupPanel) {
        let index = this.wallboard.definition.panels.findIndex(p => p.id === this.backupPanel.id);
        if (index > -1) {
          this.wallboard.definition.panels[index] = this.backupPanel
        }
        this.backupPanel = undefined;
      }
      this.addingPanel = undefined;
    },
    duplicate(panel) {
      let dupe = JSON.parse(JSON.stringify(panel));
      delete dupe.id;
      let lastId = 0;
      this.wallboard.definition.panels.forEach(p => {
        if (p.id > lastId) lastId = p.id;
      });
      dupe.id = lastId + 1;
      dupe.order = this.wallboard.definition.panels.length;
      this.wallboard.definition.panels.push(dupe);
      this.saveWallboard();
    },
    saveWallboard() {
      return axios.put("wallboards/" + this.id, this.wallboard);
    },
    createPanel() {
      if (!this.addingPanel.id) {
        let lastId = 0;
        this.wallboard.definition.panels.forEach(p => {
          if (p.id > lastId) lastId = p.id;
        });
        this.addingPanel.id = lastId + 1;
        this.addingPanel.order = this.wallboard.definition.panels.length;
        this.wallboard.definition.panels.push(this.addingPanel);
      }
      this.saveWallboard().then(() => (this.addingPanel = undefined));
    },
    deletePanel(id) {
      var index = this.wallboard.definition.panels.findIndex(p => p.id === id);
      if (index > -1) {
        this.wallboard.definition.panels.splice(index, 1);
        this.saveWallboard();
      }
    },
    getStats() {
      axios.get("wallboard/" + this.id + "/stats");
    }
  },
  computed: {
    fullscreen() {
      return this.$store.state.fullscreen;
    }
  },
  watch: {
    addingPanel: function() {
      if (!this.addingPanel) this.drawerWidth = "";
    }
  }
};
</script>

<style>
</style>
